import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * GreetingList 组件 — Greeting 列表页面
 *
 * 展示 Greeting 列表 + 创建表单，使用 useGreetings hook 管理状态。
 */
import * as React from 'react';
import { useGreetings } from '../hooks/use-greetings.js';
/**
 * GreetingList — Greeting 列表页面组件
 */
export function GreetingList(props) {
    const { title = 'Greetings', initialData } = props;
    const { greetings, loading, error, refresh, createGreeting } = useGreetings(initialData);
    // 本地表单状态
    const [author, setAuthor] = React.useState('');
    const [message, setMessage] = React.useState('');
    const [submitting, setSubmitting] = React.useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!author.trim() || !message.trim())
            return;
        setSubmitting(true);
        await createGreeting({ author: author.trim(), message: message.trim() });
        setAuthor('');
        setMessage('');
        setSubmitting(false);
    };
    return (_jsxs("div", { className: "greeting-list-container", style: { maxWidth: 600, margin: '0 auto', padding: 20 }, children: [_jsx("h1", { children: title }), _jsxs("form", { onSubmit: handleSubmit, style: { marginBottom: 20, display: 'flex', flexDirection: 'column', gap: 8 }, children: [_jsx("input", { type: "text", placeholder: "Author", value: author, onChange: (e) => setAuthor(e.target.value), required: true, style: { padding: '8px 12px', fontSize: 14 } }), _jsx("textarea", { placeholder: "Message", value: message, onChange: (e) => setMessage(e.target.value), required: true, rows: 3, style: { padding: '8px 12px', fontSize: 14, resize: 'vertical' } }), _jsx("button", { type: "submit", disabled: submitting || !author.trim() || !message.trim(), style: { padding: '8px 16px', cursor: 'pointer', alignSelf: 'flex-start' }, children: submitting ? '...' : 'Post Greeting1' })] }), error ? (_jsx("p", { style: { color: 'red' }, children: `Error: ${error}` })) : loading ? (_jsx("p", { children: "Loading greetings..." })) : (_jsxs("div", { children: [_jsxs("p", { children: [`${greetings.length} greeting(s)`, ' ', _jsx("button", { onClick: () => refresh(), style: { fontSize: 12 }, children: "refresh" })] }), greetings.length === 0 ? (_jsx("p", { style: { color: '#999' }, children: "No greetings yet. Post one above!" })) : (_jsx("div", { children: greetings.map(g => (_jsxs("div", { style: {
                                padding: '12px 16px',
                                marginBottom: 8,
                                border: '1px solid #eee',
                                borderRadius: 8,
                                backgroundColor: '#fafafa',
                            }, children: [_jsx("strong", { children: g.author }), ' ', _jsx("span", { style: { color: '#999', fontSize: 12 }, children: g.created_at }), _jsx("p", { style: { margin: '4px 0 0' }, children: g.message })] }, g.id))) }))] }))] }));
}
//# sourceMappingURL=greeting-list.js.map